export const SAMPLE_WORK_PLACEHOLDER_COVER =
  'https://placehold.jp/30/4F59CC/ffffff/300x150.png?text=Cover'

export const getMediaUrl = (mediaPath: string) => {
  if (!mediaPath) {
    return
  }

  // Add a slash if the CDN URL doesn't end with one and the mediaPath doesn't start with one
  const cdnUrl = process.env.REACT_APP_ENV_MEDIA_CDN_URL || '';
  const needsSlash = !cdnUrl.endsWith('/') && !mediaPath.startsWith('/');

  return cdnUrl + (needsSlash ? '/' : '') + mediaPath;
}
